<template>
  <v-footer
    fixed
    app
    inset
    :height="theme.footer_height"
    :color="theme.footer_bg_color"
  >
    <v-btn
      block
      dark
      large
      class="btn"
      :color="theme.btn_color_primary"
      @click="addOrder"
    >
      <v-layout row>
        <v-flex
          xs12
          class="text-xs-center"
        >
          {{ $t('add_order') }}
        </v-flex>
      </v-layout>
    </v-btn>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('config', [
      'theme', 'rid', 'gid'
    ])
  },
  methods: {
    addOrder () {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuFooter.vue